import { jsx as _jsx } from "react/jsx-runtime";
import { isEmpty } from 'ramda';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { formDialogAtom, formDialogOpenValidationAtom } from '../../recoil/';
import { AlertDialog } from '../AlertDialog/AlertDialog';
export function RecoilI18nDialog() {
    const [open, setOpen] = useState(false);
    const [globalOpen, setGlobalOpen] = useRecoilState(formDialogOpenValidationAtom);
    const [formState, setFormState] = useRecoilState(formDialogAtom);
    const { title, description, continueText, cancelText, onCancel, onContinue, continueAction = true, cancelAction = true, onExited, } = formState;
    const handleContinue = () => {
        if (onContinue)
            onContinue();
        if (formState.withValidation)
            setGlobalOpen(false);
        setOpen(false);
        // we wait a bit so the close animation can finish
        setTimeout(() => setFormState({}), 200);
    };
    const handleCancel = () => {
        if (onCancel)
            onCancel();
        if (formState.withValidation)
            setGlobalOpen(false);
        setOpen(false);
        // we wait a bit so the close animation can finish
        setTimeout(() => setFormState({}), 200);
    };
    useEffect(() => {
        // only open with validation
        if (formState.withValidation) {
            // only open if we have formData and global allows it
            if (!isEmpty(formState) && globalOpen === true)
                setOpen(true);
            // if global is closed we close
            if (globalOpen === false)
                setOpen(false);
        }
        else {
            // by default we open normal
            if (!isEmpty(formState))
                setOpen(true);
        }
    }, [formState, globalOpen, setOpen]);
    return (_jsx(AlertDialog, { open: open, title: title ?? '', description: description ?? '', continueText: continueText, cancelText: cancelText, onCancel: handleCancel, onContinue: handleContinue, continueAction: continueAction, cancelAction: cancelAction, onExited: onExited }));
}
